import React ,{Component} from 'react';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';

import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 

import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { addDays } from "date-fns";
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox'; 
import FormControlLabel from '@mui/material/FormControlLabel'; 
import BrowserNotSupportedOutlinedIcon from '@mui/icons-material/BrowserNotSupportedOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ReactToPrint from 'react-to-print';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
//import { styled } from '@mui/material/styles';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import Uploadfile from './Uploadfile';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
	   import PaymentRefBox from './Paymentdetails';       
 import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
  import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import Box from '@mui/material/Box';
import StepLabel from '@mui/material/StepLabel';
import Sendemail from './Sendemailsalescreditnote';
import Payment from './Payment';

import Sharelink from './Sharelink';
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(100%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 100,
});


const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
  

  table: {
    minWidth: 750,
  },
  
});



function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}



export default class Salescreditnoteviewmore extends Component {
	
    constructor(props) {
    super(props);
	
 this.state = {open:false, addopen: false,creditNoteId:'',cu_id:'',cu_emailid:'',
	 sin_reference:'',invoiceid:'',scn_id:'',erropen:false,errortype:"error",errormessage:"",previcon:'',
	notedate:'',productviewData:[],pdffile:'',snstatus:"",entrydate:'',
	 CreditNoteData:[],page:0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],grandtotal:"0.00",
search:'',order:'desc' ,orderBy:'cop_id',customername:'',taxbrkupsarr:[],taxsumarr:[],subtotal:"0.00",
	  
	urllink:'',activeStep:0,active:'',setactiveStep:0,	totalamount:0,outstandingamt:0,paycount:0,paytext:"payments",
		
	}
	      this.updateDonenewParent=this.updateDonenewParent;  
	}
	
	
 updateDonenewParent = (event) => {
	 this.Creditnoteviewmore();
	 
 }
	
	
	componentWillMount() { 
	


	

	let strname="Sales Credit Notes";
		   
	 this.props.parentdasCallback(
            strname+"~"
        );
	  this.Creditnoteviewmore();
	
	  
	
	}
 getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}




Productgetall(scnoid) {
	axios.get(localStorage.getItem("ISIurl")+'ajaxcreditnoteproduct.php?action=getall&cop_scn_id='+scnoid+'&sorting=cop_id')

		.then(resp => {
			if (resp.data.length > 0) {
				this.setState({
					productviewData: resp.data,
					taxid: resp.data[0].iop_tax_id
				}, () => {
				
					this.Taxcalculate();
					
					
				});
			} else {
				this.setState({
					productviewData: [],
					totaldata: 0
				});
			}
		})
		
}






handleClickOpen = (e) => { 
  this.setState({open:!this.state.open,
	  });
	  
		
};

handleClickOpen = (e) => { 
  this.setState({addeopn:!this.state.addeopn,
	  });
	  
		
};

Creditnoteviewmore() {
    let search = window.location.href;
    let Scnoid = this.getParameterByName('scnoid', search);

    axios.get(localStorage.getItem("ISIurl") + 'ajaxsalescreditnote.php?action=getall&scn_id=' + Scnoid)
        .then(resp => {
            if (resp.data.length > 0) {
              
                this.setState({pdffile:resp.data[0].scn_pdffile,
                    CreditNoteData: resp.data,cu_id:resp.data[0].scn_cu_id,
					scn_id:resp.data[0].scn_id,entrydate:resp.data[0].scn_createddate,
                    invoiceid:resp.data[0].scn_id,cu_emailid:resp.data[0].cu_emailid,
					 notedate:resp.data[0].notedate,
					 reference:resp.data[0].scn_reference,
					 customername:resp.data[0].cu_contactname,
                    snstatus:resp.data[0].scn_status,previcon:resp.data[0].scn_file,
                },()=>{});
				 let strname="Sales Credit Notes: "+resp.data[0].scn_quotenumber;
		   
	 this.props.parentdasCallback(
            strname+"~"
        );
				  this.Productgetall(Scnoid); 
            } else {
                this.setState({ CreditNoteData: []});
            }
        });
}

handlAddfileopen = () => {
        
  this.refs.Uploadfile.handleaddfileClose();
}
   handlemailopen = () => {
        const currentUrl = window.location.href; 
        this.setState({ urllink: currentUrl });
        this.setState({ open: true }); 
    }; 
	
	
	
	 
	





   
  
onSelectedTaxbyid(txid,taxarr){
	
		 axios.get(localStorage.getItem("ISIurl")+'ajaxtax.php?action=taxid&tx_id='+txid+'&tx_cmp_id='+localStorage.getItem("ISIcmpid")+'&dwt_fromdate='+this.state.entrydate)
  .then(resp => {  
    let strarraytax=[];
	
   if(resp.data.length>0){
	   
  
	
	var rowsArrayp = resp.data;
 
	 rowsArrayp.map((txrow, j) => {
	const taxitems = {
        taxname:txrow.tx_name,
         taxmid:txrow.tx_mainid,
		 taxper:txrow.dwt_percentage,
          taxamt:0 ,
		   taxablevalue:0
        };
		strarraytax.push(taxitems);
		});
		let sretax= this.state.taxsumarr
		let mergedarray = strarraytax.map(function(item) {
    sretax.map(function(item2) {
        if (item.taxmid == item2.Id) {
            item.taxamt=item2.total;
			 item.taxablevalue=((parseFloat(item2.total)*parseFloat(item.taxper))/100).toFixed(2);
			
        }
    });
  return item;
   });

	this.setState({ taxbrkupsarr:mergedarray})


	   
   }
   
   
  });

}
Taxcalculate(){
	let optionstaxRep = this.state.productviewData;
let profit=0.00,strsubtotal=0.00,strdiscount=0.00;
	
	 var srearray=optionstaxRep.filter(value => value.pr_isdeleted  < 1)
	optionstaxRep  = [].concat(optionstaxRep).sort(function(a, b) {
    return a.taxid > b.taxid ? 1 : -1;
  })
let previoustax="",strcurnttax="",prerow=0,rate="",totaltaxamt=0,taxamount=0,totalamount=0;
	let  strgrantotal=0,strtotaldiscount=0;
	
let strtaxid="",strsep="";

const arr = optionstaxRep;

const out = {};

for (const { salesprice,qty,discount, taxid,tax } of arr) {
  out[taxid] ??= { taxid, total: 0,taxamt:0 };
  const subtotal = out[taxid].total + ((parseFloat(salesprice)* parseFloat(qty))-parseFloat(discount));
   const taxtotal = out[taxid].taxamt + Number(tax);
   strtaxid=strtaxid+strsep+taxid;
		strsep=",";
  out[taxid] = { ...out[taxid], total: subtotal,taxamt:taxtotal };
}

this.onSelectedTaxbyid(strtaxid,out);


    optionstaxRep.forEach(eachrep => {
		
			  
			  strcurnttax=eachrep.taxid;
			  
			  
			 
			strsubtotal  =parseFloat(strsubtotal)+parseFloat(eachrep.total)
	
		strgrantotal=parseFloat(strgrantotal)+parseFloat(eachrep.total)
	
		strdiscount=parseFloat(strdiscount)+parseFloat(eachrep.discount)
	
		
	});

	 this.setState({subtotal:parseFloat(strsubtotal).toFixed(2),grandtotal:parseFloat(strgrantotal).toFixed(2),salesdiscount:strdiscount,Grndtotal: parseFloat(strgrantotal).toFixed(2),
						outstandingamt: parseFloat(strgrantotal)},()=>{this.GetTotalById(this.state.scn_id);});
}
handlestatusupdate = (e) =>{

   let search = window.location.href;
    let Scnoid = this.getParameterByName('scnoid', search);

				 var formData = new FormData(); 
					 formData.append('action','statusupdate')
					formData.append('scn_id',Scnoid)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
					 formData.append('scn_status',5)
				
					 axios.post(localStorage.getItem("ISIurl")+"ajaxsalescreditnote.php", formData, {
						}).then(res => {
					

	
					this.setState({erropen:true,errormessage:'Status has been Updated', errortype:"success"});
					this.Creditnoteviewmore();
						}) 
		 
	
}


handleClickOpen = (e) => { 
  this.setState({open:!this.state.open
	  });
		
};




Deletecreditnote= (e) =>{  
  
   let search = window.location.href;
    let Scnoid = this.getParameterByName('scnoid', search);

		let r = window.confirm("Do you really want to Delete?");
		 if(r === true){ 
				 var formData = new FormData(); 
					 formData.append('action','delete')
					
					 formData.append('scn_id',this.state.scn_id)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
				
					  axios.post(localStorage.getItem("ISIurl")+"ajaxsalescreditnote.php", formData, {
						}).then(res => {
					
						if(res.data === 1)
{ 
	
					this.setState({redirect:true,pagename:'/Adminsalescreditnote'});
}					
						}) 
						
					//this.Creditnoteviewmore();	
						
		 }
 }


handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }

sendEmail = (e) => {
 
    e.preventDefault();
  
    let formData = new FormData();
    formData.append('action', 'sendemail');
    formData.append('scn_id', this.state.scn_id);
     formData.append('scn_cmp_id' ,localStorage.getItem("ISIcmpid"));
    
    axios.post(localStorage.getItem("ISIurl") + "ajaxsalescreditnote.php", formData)
        .then(response => {
           
            console.log("Email sent successfully:", response.data);
			this.setState({activeStep: this.state.activeStep+1});
        })
        .catch(error => {
           
            console.error("Error sending email:", error);
        });
};
















/*paymentgetall */

GetTotalById(scnoid) {
  axios.get(localStorage.getItem("ISIurl") + 'ajaxpayments.php?action=gettotal&pmt_type=2&pref_mainid=' + scnoid)
    .then(resp => {
      if (resp.data.length > 0) {
     

        this.setState({
        lastdate:resp.data[0].lasttransaction,
       totalamount: parseFloat(resp.data[0].totalpaid).toFixed(2),

		outstandingamt: (parseFloat(this.state.outstandingamt) - parseFloat(resp.data[0].totalpaid)).toFixed(2),

      paycount:resp.data[0].cnt,

	  },()=>{
		 
	  });
      } 
	  
	  
	  
	  
	  else {
        this.setState({ totalamount: 0 });
      }
	  
	  
	  
    });
}


 handleAddpayment = () => {
	
	this.refs.Payment.handleaAddpaymentClose();
}
 


/**/


 addpayrefbox(){
    let search = window.location.href;
   
    setTimeout(() => this.refs.PaymentRefBox.handleClickOpen(),500);

 }






	render() {
		
		  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
		

		let subtaotal = 0;
		let totalitem=0;
    return (
	
<React.Fragment>	

<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	  {this.state.scn_id!="" && (
<Sendemail ref="Sendemail"  headingname="Sales Credit Note"
aoid="9"
  id={this.state.scn_id} emailid={this.state.cu_emailid}   />
	  )}
  <div className="estimateviewcontainer">
    <div className="estimateviewerleftbox">
      <div className="estimateviewmorebox">
        <div className="custgreencolor">
          To: <span className="lighgreencolor">{this.state.customername}</span>
        </div>
        
        <div className="estaddressdata">
          <Table width="100%">
            <tr>		
              <td align="left" style={{"width": "10%"}}>	
                {this.state.CreditNoteData.map((item,index) => { 
                  return (
                    <React.Fragment>
                      <div className="invoiceaddress">
                        
                          <p><b>Invoice Address</b><br/>
                          {item.scn_billingaddress1}<br/>
                          {item.scn_billingaddress2}<br/>
                          {item.scn_billingcity}<br/>
                          {item.scn_billingstate} - {item.scn_billingpincode}<br/>
                      </p>
                      </div>
                    </React.Fragment>
                  );
                })}
              </td>

              <td align="left" style={{"width": "10%"}}>
                {this.state.CreditNoteData.map((item,index) => { 
                  return (
                    <React.Fragment>
                      <div className="invoiceaddress">
                       
                          <p><b>Delivery Address</b>
                         {item.scn_shippingaddress1}<br/>
                         {item.scn_shippingaddress2}<br/>
                         {item.scn_shippingcity}<br/>
                         {item.scn_shippingstate} - {item.scn_shippingpincode}
                         </p>
                      </div>
                    </React.Fragment>
                  );
                })}
              </td>

              <td align="left" style={{"width": "10%"}}> 
                <p><b>Created Date</b></p>
                <p>{this.state.notedate}</p>
              </td>

              

              <td align="left" style={{ width: "10%" }}>
                {this.state.reference && (
                  <>
                    <p><b>Reference</b></p>
                    <p>{this.state.reference}</p>
                  </>
                )}
              </td>
            </tr>
          </Table>
        </div>
        
		
			
	<PaymentRefBox 
ref="PaymentRefBox"   pmt_type={2}
outstandingamt={this.state.outstandingamt}
updateDonenew={this.updateDonenewParent}
pref_mainid={this.state.scn_id}

/>
 
		
		
		
		
<Payment ref="Payment" 
cu_id={this.state.cu_id}
           pref_mainid={this.state.scn_id }
           scn_status={this.state.scn_status}
           Grndtotal={this.state.outstandingamt}
           updateDonenew={this.updateDonenewParent}
		   pmt_type={2}
/>


		
		
		
		
		
		
		
        <div ref={el => (this.componentRef = el)}  >
          <Paper>
            <TableContainer className="table-container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="table-head">Item Description</TableCell>
                    <TableCell className="table-head">Qty</TableCell>
                    <TableCell className="table-head ">Price</TableCell>
                    <TableCell className="table-head ">Discount</TableCell>
                    <TableCell className="table-head ">Tax</TableCell>
                    <TableCell className="table-head ">Sub Total</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {stableSort(this.state.productviewData, getSorting(this.state.orderBy, this.state.order)).map((item, index) => {
                    subtaotal = Number(subtaotal) + Number(item.cop_total);
                    totalitem = Number(totalitem) + Number(item.cop_quantity);
                    return (
                      <React.Fragment key={index}>
                        <TableRow className="table-cell" style={{ backgroundColor: '#f1f5f6' }}>
                          <TableCell className="table-cell">
                            <p>{item.cop_description}</p>
                            <p><i>{item.ledgername}({item.le_code})</i></p>
                          </TableCell>
                          <TableCell className="table-cell">{item.cop_quantity}</TableCell>
                          <TableCell className="table-cell">{item.cop_price} </TableCell>
						  <TableCell className="table-cell">{item.cop_discount}</TableCell>
                          
                          <TableCell className="table-cell"><p>{item.cop_taxvalue}</p><p>{item.tx_name}</p> </TableCell>
                          <TableCell className="table-cell">{item.cop_total} </TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })}

				  {this.state.productviewData.length>0 &&(
				  <React.Fragment>
                  <TableRow>
                    <TableCell colSpan="4"></TableCell>
                    <TableCell><b>Sub Total</b></TableCell>
                    <TableCell align="left">{parseFloat(this.state.subtotal).toFixed(2)} </TableCell>
                  </TableRow>


                <TableRow>
                    <TableCell colSpan="4"></TableCell>
                    <TableCell><b>Tax Breakdown</b>
						{this.state.taxbrkupsarr.length>0 && (<React.Fragment>
		<div className="taxdiv">
		{this.state.taxbrkupsarr.map((rows,i) => {


				
           return ( <React.Fragment>
		   
		<p ><b>{rows.taxname}: {rows.taxamt}  @ {rows.taxper}%</b></p> 
	
		   </React.Fragment>)
		   
		})}
	</div></React.Fragment>
		)}
					</TableCell>
                    <TableCell align="left">{this.state.taxbrkupsarr.length>0 && (<React.Fragment>
		
		{this.state.taxbrkupsarr.map((rows,i) => {


				
           return ( <React.Fragment>
		   
		 <p >{rows.taxablevalue}</p>
	
		   </React.Fragment>)
		   
		})}
	</React.Fragment>
		)}</TableCell>
                  </TableRow>


                  <TableRow>
                    <TableCell colSpan="4"></TableCell>
                    <TableCell><b><h4>Total</h4></b>({totalitem}) Items</TableCell>
                    <TableCell align="left">{parseFloat(this.state.grandtotal).toFixed(2)}</TableCell>
                  </TableRow>
				  </React.Fragment>
				  )}
				  
				  
				  {this.state.productviewData.length===0 &&(
				  
                 <TableRow>
                 <TableCell  >
                  No Products Found
                  </TableCell>
                </TableRow>

				  
				  
				  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
       </div>
      </div>
    </div>
  {localStorage.getItem("ISIuserid")!=null &&(
    <div className="estimateviewerightbox">
      
	  <div className="invoiceupdatebox">
	  
		
		<div className="stepperheader">		
		<div className="carbon-pod__content"><div className="s1a-timeline-container"><div className="s1a-timeline-pip-container"><span className="carbon-icon s1a-timeline-pip-icon icon-tick" aria-label="created" data-component="icon" data-element="tick" tabindex="0"></span><div className="s1a-timeline-pip-title"><span>created</span></div></div><div className="s1a-timeline-pip-container"><span className="carbon-icon s1a-timeline-pip-icon icon-default" aria-label="sent" data-component="icon" data-element="default"></span><div className="s1a-timeline-pip-title"><span>sent</span></div></div><div className="s1a-timeline-pip-container"><span className="carbon-icon s1a-timeline-pip-icon icon-default" aria-label="viewed" data-component="icon" data-element="default"></span><div className="s1a-timeline-pip-title"><span>viewed</span></div></div>

</div></div>
	  </div>
		
	  
	  </div>
	  
	  
	  
	
<React.Fragment>
	  
	   
	  
 <div className="invoiceupdatebox">
	  <div className="stepperheader">	
	  <div className="amountpaidbox">
	     <p><b>Amount Paid</b></p>
		  <h4><b>$ {this.state.totalamount}</b></h4>
	     {this.state.totalamount!=0 && (
	    	<p><span className="greentextcolor">{this.state.paycount}&nbsp;
	
	     	<span className="paytext" onClick={()=>{this.addpayrefbox()}}>{this.state.paytext}</span> 	&nbsp;</span> on {this.state.lastdate}</p>
	       )}
	
	  </div>
		
		
		
		
		<div className="outstadingpaybox">
		
		<p><b>Amount Outstanding</b></p>
		<h4>${this.state.outstandingamt}</h4>
		
		</div>
		
		<div className="clear"></div>
	   {this.state.snstatus!=="4" && (
		<div className="createinvoicebox">
		  <h3 onClick={this.handleAddpayment}>Record Payment </h3>
		  
		</div>
	   )}
	   
	   </div>
	  </div>
	   </React.Fragment>
	  
	  
	  
	 
	  
	  <div className="invoiceupdatebox">
	  
	
		
		    <div className="invoiceupdatebox">
	  
		
		   <div className="Viewfunctionality">
            <ul> <li>
            <p onClick={()=>{this.refs.Sharelink.handlSharebox()}}>
          
                <ShareOutlinedIcon /> &nbsp; Share
            </p>
             </li>
			 
			 <li>
            <p className="icon-text">
               <a href={localStorage.getItem("ISIurl")+"uploads/"+this.state.pdffile} target="_blank"  target="_blank" ><LocalPrintshopOutlinedIcon /> &nbsp; Print
				
				</a>
            </p>  
             </li>
			 
			  {this.state.snstatus!=="3" && ( 
			 <li>
            <p className="icon-text" onClick={this.handlAddfileopen}>
            <AttachFileOutlinedIcon /> &nbsp; Add file
          </p>

             </li>)}
			 
			   {this.state.previcon!="" && (
		     <li><p className="icon-text" >
		  <AttachFileOutlinedIcon className="verticalalign"/> <a href={localStorage.getItem("ISIurl")+"uploads/"+this.state.previcon} target="_blank">View File</a>
		 </p>  </li>)}
			 <li>
            <p className="icon-text" onClick={()=>{this.refs.Sendemail.handleaddfileClose()}}>
   
  <MailOutlinedIcon /> &nbsp; Email




            </p>
             </li>{this.state.snstatus!=="4" && (
			  <li>
            <p className="icon-text">
                <a className="link" href={"#/AddSalescreditnotes?scnid="+this.state.scn_id+""}><EditOutlinedIcon /> &nbsp; Edit
            </a></p>
             </li>
			 )}
			 
			   <li>
            <p className="icon-text">
              <a  
			    href={localStorage.getItem("ISIurl")+"uploads/"+this.state.pdffile} target="_blank"
                > <CloudDownloadOutlinedIcon />&nbsp; Download</a>
            </p>
			</li>

           <li>
            <p className="icon-text">
              <a className="link" href={"#/AddSalescreditnotes?scnid="+this.state.scn_id+"&copy=1"}> <ContentCopyOutlinedIcon />&nbsp; Copy</a>
            </p>
			</li>
      
			<li>
            <p className="icon-text" onClick={this.Deletecreditnote}>
              <DeleteOutlineOutlinedIcon />&nbsp; Delete
            </p>
			</li>
			{(this.state.snstatus!=="5" && this.state.snstatus!=="4") && (
		 <li>
            <p className="icon-text" onClick={this.handlestatusupdate}>
              <BrowserNotSupportedOutlinedIcon />&nbsp; Void
            </p>
			</li>
			)}
             </ul>
               </div>
</div>
	  </div>
	</div>)}
	  
	  
    
  </div>

  <div className="clear"></div>
  

   <Sharelink ref="Sharelink" />
  
  
  



  <div className="addfile">

     
			  <Uploadfile ref="Uploadfile" id={this.state.scn_id}   strrtype={3} updateDonenew={this.updateDonenewParent}/>
			  
</div>
  
</React.Fragment>
    );
}

}